import { Layout } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import Navbar from '../../components/Organisms/Navbar/Navbar';
import { useAppDispatch } from '../../store/hooks/hooks';
import { userSubMenu } from '../../utils/functions';
import './Dashboard.less';
/**
 * @page Dashboard.tsx
 * @description Main page for the admin.
 * @return { page }
 */
function Dashboard() {
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  const itemsCallback = (item: string) => {
    userSubMenu(item, navigate, dispatch);
  };
  return (
    <Layout>
      <Navbar showItems={false} itemsCallback={itemsCallback}/>
      <Outlet />
    </Layout>
  );
}

export default Dashboard;
